import React, { useEffect } from 'react';

const CustomModal = ({ isOpen, onClose, children, className = 'max-w-[575px]', isX = true }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/55 transition-opacity duration-300 ease-in-out ${
        isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative w-[95%] transform rounded-2xl bg-white shadow transition-transform duration-300 ${
          isOpen ? 'scale-100' : 'scale-90'
        } ${className ? className : ''}`}
      >
        {isX && (
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-[21px] z-50 bg-transparent"
          >
            <img src="/images/icons/cancel.svg" alt="close" className="h-4 w-4 object-contain" />
          </button>
        )}

        <div className="h-full space-y-4">{children}</div>
      </div>
    </div>
  );
};

export default CustomModal;
